import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, NavigationStart, NavigationExtras, Router } from '@angular/router';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../../../services/auth.service';
import { EnvService } from '../../../services/env.service';
import { CommonService } from '../../../services/common.service';

import { DelComponent } from '../../../confirm/del/del.component';

@Component({
	selector: 'app-rview',
	templateUrl: './rview.component.html',
	styleUrls: ['./rview.component.css']
})
export class RviewComponent implements OnInit {

	admPageObj:any = "curr";

	logi_user:any;
	idx:any;
	orData:any = [];

	/* 페이징 */
	cp:any = 1;

	/* 검색관련 */
	skey:any = "";
	sw:any = "";
	sdate:any = "";
	edate:any = "";
	st1:any;
	st2:any;
	st3:any;
	st4:any;
	st5:any;
	st6:any;

	constructor(
		private http: HttpClient,
		public router: Router,
		public route: ActivatedRoute,
		public dialog: MatDialog,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) { }

	ngOnInit() {
		this.idx = this.func.getParameterByName("idx", window.location.href);
		if( this.idx == null ){ this.idx = ""; }

		this.cp = this.func.getParameterByName("page", window.location.href);
		if( this.cp == null ){ this.cp = ""; }

		this.skey = this.func.getParameterByName("skey", window.location.href);
		if( this.skey == null ){ this.skey = ""; }

		this.sw = this.func.getParameterByName("sw", window.location.href);
		if( this.sw == null ){ this.sw = ""; }

		this.sdate = this.func.getParameterByName("sdate", window.location.href);
		if( this.sdate == null ){ this.sdate = ""; }

		this.edate = this.func.getParameterByName("edate", window.location.href);
		if( this.edate == null ){ this.edate = ""; }

		this.st1 = this.func.getParameterByName("st1", window.location.href);
		if( this.st1 == null ){ this.st1 = "1"; }

		this.st2 = this.func.getParameterByName("st2", window.location.href);
		if( this.st2 == null ){ this.st2 = "1"; }

		this.st3 = this.func.getParameterByName("st3", window.location.href);
		if( this.st3 == null ){ this.st3 = "1"; }

		this.st4 = this.func.getParameterByName("st4", window.location.href);
		if( this.st4 == null ){ this.st4 = "1"; }

		this.st5 = this.func.getParameterByName("st5", window.location.href);
		if( this.st5 == null ){ this.st5 = "1"; }

		this.st6 = this.func.getParameterByName("st6", window.location.href);
		if( this.st6 == null ){ this.st6 = "1"; }

		this.getOrderData(this.idx);
	}

	async getOrderData(idx) {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("idx", idx);

		this.http.post(this.env.API_URL + 'api/order.data.php', formData).subscribe((response) => {
			if( response['data'] )
			{
				this.orData = response['data'];
			}
		});
	}

	async delConfirm(idx) {
		const dialogRef = this.dialog.open(DelComponent,{
			panelClass: 'confirm-class',
			width: "280px",
			data: {
				title: '오더 삭제',
				message: '해당 오더를 삭제하시겠습니까? 삭제된 내용은 복구하실 수 없습니다.',
				idx: idx
			},
		});

		dialogRef.afterClosed().subscribe(result => {
			console.log(result);
			//this.orderDel(result);
		});
	}

	async orderDel(idx) {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("idx", idx);

		this.http.post(this.env.API_URL + 'api/order.delete.php', formData).subscribe((response) => {
			this.router.navigate(['/admin/request', { page: this.cp, skey: this.skey, sw: this.sw }]);
		});
	}

	request() {
		let navigationExtras: NavigationExtras = {
			queryParams: {
				page: this.cp,
				sw: this.sw,
				skey: this.skey,
				sdate: this.sdate,
				edate: this.edate,
				st1: this.st1,
				st2: this.st2,
				st3: this.st3,
				st4: this.st4,
				st5: this.st5,
				st6: this.st6
			}
		};

		this.router.navigate(['/admin/request'], navigationExtras);
	}
}
